<template>
  <div>
    <a-row v-for="item in localValue" :gutter="4" :style="{margin:'12px'}">
      <a-col :span="20">
        <a-select v-model:value="item.id" :placeholder="placeholder" style="width: 100%">
          <a-select-option v-for="opt in options" :value="opt.value" :key="opt.value"> {{ opt.name }} </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4">
        <a-button type="link" @click="removeItem(item)">删除</a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-button type="link" icon="download" @click="addItem">
          {{addLabel}}
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
//TODO: 修改
import {getRegionTree as initApi} from '../../../api/api'
export default {
    name: "index",
    mixins:[mixin],
    props: {
        addLabel: {
            type: String,
            //TODO: 修改
            default: '继续添加组员'
        },
        placeholder: {
            type: String,
            //TODO: 修改
            default: '请选择本次检查小组组员'
        }
    },
    data() {
        return {
            options:[],
            localValue: []
        }
    },
    created(){
      this.init()
    },
    methods:{
        init(){
            if(!(this.localValue&&this.localValue.length))
            {
                this.localValue=[{id:''}]
            }
            initApi("\'city\'").then(result => {
                if (result.data && result.data.succ) {
                    this.options = result.data.data;
                }
            }).catch(() => {
                this.options=[];
            })
        },
        addItem()
        {
            this.localValue.push({id:''});
        },
        removeItem(item)
        {
            this.localValue.remove(item);
        }
    }

}
</script>

<style scoped>
  .list-header {
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>